import axios from "axios";

const API_URL = "/api/groupages/";
const API_URL_SHIPMENTS = "/api/groupages/shipments/";

// get groupages
const getGroupages = async (query, token) => {
  const config = {
    params: query,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(API_URL, config);
  return response.data;
};

// get groupages
const getGroupage = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

// update groupage
const updateGroupage = async (data, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.put(API_URL + data.id, data, config);
  return response.data;
};

// delete groupage
const deleteGroupage = async (data, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.delete(API_URL + data.id, config);
  return response.data;
};

// create groupage
const createGroupage = async (data, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(API_URL, data, config);
  return response.data;
};

// add shipment to groupage
const addShipmentToGroupage = async (data, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(API_URL_SHIPMENTS, data, config);
  return response.data;
};

// bulk add shipment to groupage
const bulkAddShipmentToGroupage = async (data, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(API_URL_SHIPMENTS + "bulk", data, config);
  return response.data;
};

// bulk remove shipment from groupage
const removeShipmentsFromGroupage = async (data, token) => {
  const config = {
    headers: {
      Authorization: `Bearer: ${token}`,
    },
  };

  const response = await axios.post(API_URL_SHIPMENTS + "remove", data, config);
  return response.data;
};

const generateQr = async (groupageId, token) => {
  const response = await axios.get(
    "/api/shipments/document/qrgroupage/" + groupageId,
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response;
};

const groupageService = {
  getGroupages,
  getGroupage,
  createGroupage,
  updateGroupage,
  addShipmentToGroupage,
  bulkAddShipmentToGroupage,
  deleteGroupage,
  removeShipmentsFromGroupage,
  generateQr,
};

export default groupageService;
